export const environment = {
  production: true,
  apiUrl: '/api',
    images360: '/api/sale-mgr/',
};
